








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "ICheckContactBlock"
})
export default class ICheckContactBlock extends Vue {
  @Prop({type: String, default: '24'}) width !:any
  @Prop({type: String, default: '#2D9CDB'}) color !:any

  click() {
    this.$emit('click')
  }
}
